import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Candidate, CandidateCreate, CandidateFilter } from '../data/candidate';

export function createCandidateService(client: AxiosInstance) {
  return createCrudService<Candidate, CandidateCreate, CandidateFilter>(
    client,
    '/hrm/Candidate',
    'id',
  );
}

export type CandidateService = CrudService<Candidate, CandidateCreate, CandidateFilter>;
